import React from 'react';

// Digital HIG Components
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";

interface PopupContentProps {
  children: React.ReactNode;
}

export const PopupContent: React.FC<PopupContentProps> = ({ children }) => {
  return (
    <DHBox
      sx={{
        width: '736px',
        height: '176px',
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
    >
      {children}
    </DHBox>
  );
};

